import { Box, Typography } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import {
  LocationAutocomplete,
  type Props as LocationAutocompleteProps,
} from '../LocationSearchBar/LocationAutocomplete';

export const Header = (props: LocationAutocompleteProps) => {
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        display: 'flex',
        py: 2,
        px: { xs: 2, md: 3 },
        justifyContent: 'space-between',
        backgroundColor: 'common.white',
        alignItems: {
          xs: 'start',
          md: 'center',
        },
        flexDirection: {
          xs: 'column',
          md: 'row',
        },
        gap: 1.5,
      }}
    >
      <Typography
        variant={isMobile ? 'h4' : 'h3'}
        component="h1"
        sx={{
          pr: { xs: 0, md: 5 },
          flexShrink: 0,
          color: 'other.spaceCadet',
        }}
      >
        Partner Map
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          width: '100%',
          maxWidth: 600,
          flexGrow: 1,
        }}
      >
        <LocationAutocomplete {...props} />
      </Box>
    </Box>
  );
};
